import { ExtendedApiObject } from '@bpd-library/utilities';

import { GTMPush } from './gtm';

export interface GTMMapboxObject {
    area_id?: string | null;
    area_name?: string | null;
    project_id?: string | null;
    project_name?: string | null;
    wijk_id?: string | null;
    id?: string | null;
    status?: string | null;
}

export type PolygonDimensionality = '2D' | '3D';

const defaultProperties = {
    event: 'Map Interaction',
    eventCategory: 'Map',
    eventAction: 'Polygon interaction',
};

export const handleGTMPolygonInteraction = async (
    apiObject?: ExtendedApiObject,
    dimensionality: PolygonDimensionality = '2D',
) => {
    if (!apiObject) return;

    const { areaProjectName } = window.__ENVIRONMENT_DETAILS__;

    switch (apiObject.objectType) {
        case 'areaProject':
            GTMPush({
                ...defaultProperties,
                dimensionality,
                eventLabel: `${areaProjectName}`,
                polygonCategory: apiObject.objectType,
            });

            break;
        case 'district':
            GTMPush({
                ...defaultProperties,
                dimensionality,
                eventLabel: `${areaProjectName} - ${apiObject.name}`,
                polygonCategory: apiObject.objectType,
            });

            break;
        case 'apartmentBuilding':
            GTMPush({
                ...defaultProperties,
                dimensionality,
                eventLabel: apiObject.displayName,
                polygonCategory: apiObject.objectType,
                mapboxHouse: <GTMMapboxObject>{
                    area_id: apiObject.areaProjectId,
                    area_name: apiObject.projectPhase?.areaProjectName,
                    project_id: apiObject.projectPhaseId,
                    project_name: apiObject.projectPhaseName,
                    wijk_id: apiObject.projectPhase?.districtId,
                    id: apiObject.id,
                    status: apiObject.status,
                },
            });

            break;
        case 'constructionNumber':
            GTMPush({
                ...defaultProperties,
                dimensionality,
                eventLabel: `${apiObject.propertyTypeName} ${apiObject.identifier}`,
                polygonCategory: apiObject.objectType,
                mapboxHouse: <GTMMapboxObject>{
                    area_id: apiObject.areaProjectId,
                    area_name: apiObject.projectPhase?.areaProjectName,
                    project_id: apiObject.projectPhaseId,
                    project_name: apiObject.projectPhaseName,
                    wijk_id: apiObject.projectPhase?.districtId,
                    id: apiObject.id,
                    status: apiObject.status,
                },
            });

            break;
        case 'propertyType':
            GTMPush({
                ...defaultProperties,
                dimensionality,
                eventLabel: apiObject.name,
                polygonCategory: apiObject.houseType,
                mapboxHouse: <GTMMapboxObject>{
                    area_id: apiObject.areaProjectId,
                    area_name: apiObject.projectPhase?.areaProjectName,
                    project_id: apiObject.projectPhaseId,
                    project_name: apiObject.projectPhaseName,
                    wijk_id: apiObject.projectPhase?.districtId,
                    id: apiObject.id,
                    status: apiObject.status,
                },
            });

            break;
    }
};
